import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { Plus as PlusIcon } from "@phosphor-icons/react/Plus";
import { FC } from "react";
import { useWebRouter } from "~utils/next-router/use-web-router";

export const PortalActionCard: FC<{
	title: string;
	onClick?: () => void;
	href?: string;
}> = ({ title, onClick, href }) => {
	const router = useWebRouter();

	return (
		<Box
			sx={{
				bgcolor: "var(--mui-palette-neutral-50)",
				borderRadius: "20px",
				overflow: "hidden",
				position: "relative",
				p: 2,
				"&:hover": {
					cursor: "pointer",
				},
			}}
			onClick={() => (onClick ? onClick() : href && router.push(href))}>
			<Stack
				height="100%"
				justifyContent="center"
				alignItems="center">
				<Button
					startIcon={<PlusIcon />}
					variant="contained"
					sx={{ maxWidth: "240px" }}>
					{title}
				</Button>
			</Stack>
		</Box>
	);
};
